import React, { useEffect } from 'react'

import ButtonPrimary from '~/components/Button/ButtonPrimary'
import ButtonSecondary from '~/components/Button/ButtonSecondary'

import './ModalLoginError.scss'

export default function ModalLoginError({ handleLoginByGuest, onRequestClose }) {
  
  useEffect(() => {
    return () => {
      onRequestClose()
    }
  }, [])

  function handleGuest() {
    onRequestClose()
    handleLoginByGuest()
  }

  return (
    <div className="modal-login-error">
      <h1 className="modal-login-error__title">
        Essa conta está encerrada.
      </h1>

      <p className="modal-login-error__paragraph">
        Acompanhe nossa Assembleia através do acesso para comunidade.
      </p>

      <div className="modal-login-error__actions">
          <ButtonSecondary onClick={onRequestClose}>
            Sair
          </ButtonSecondary>

          <ButtonPrimary onClick={handleGuest}>
            Entrar como comunidade
          </ButtonPrimary>
        </div>
    </div>
  )
}
